import { render, staticRenderFns } from "./AdminImportLink.vue?vue&type=template&id=09c773c6"
import script from "./AdminImportLink.vue?vue&type=script&lang=js"
export * from "./AdminImportLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports